const React = require("react");
const {openPopupWindow} = require("../../../emitters/popup");
const Popup = require("../../dumb/Popup/C");
const {FormWrapper, FormFooter} = require("../../dumb/FormHandlers");
const {AdminInput} = require("../../dumb/FormInputs");
const {API_URL_HOST} = require("../../../config/api");
const {STORAGE_API} = require("../../../constants/localSrotage");

module.exports = (data, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Change Api</div>
          </div>
        )}
      >
        <FormWrapper
          data={{hostname: API_URL_HOST}}
          onResult={(res) => {
            localStorage.setItem(STORAGE_API, res.hostname);
            window.location.reload();
          }}
        >{(formCtx) => {
          return (
            <>
              <AdminInput
                name="hostname"
                className="mt25 mb-25"
                formCtx={formCtx}
              />
              <FormFooter
                submitBtnData={{
                  text: 'Change hostname',
                  formCtx
                }}
              />
            </>
          )
        }}</FormWrapper>
      </Popup>
    );
  };
});
